var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTableActiveUltra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_20_00440"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_20_00440)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,3.187500476837158L1,12.812500476837158C1,13.537400476837158,1.587626,14.125000476837158,2.3125,14.125000476837158L13.6875,14.125000476837158C14.4124,14.125000476837158,15,13.537400476837158,15,12.812500476837158L15,3.187500476837158C15,2.4626264768371584,14.4124,1.8750004768371582,13.6875,1.8750004768371582L2.3125,1.8750004768371582C1.587626,1.8750004768371582,1,2.4626264768371584,1,3.187500476837158ZM2.12688,12.998100476837159Q2.05,12.921200476837159,2.05,12.812500476837158L2.05,10.275000476837159L5.2875,10.275000476837159L5.2875,13.075000476837157L2.3125,13.075000476837157Q2.20377,13.075000476837157,2.12688,12.998100476837159ZM6.3375,13.075000476837157L10.1,13.075000476837157L10.1,10.275000476837159L6.3375,10.275000476837159L6.3375,13.075000476837157ZM11.15,13.075000476837157L13.6875,13.075000476837157Q13.7962,13.075000476837157,13.8731,12.998100476837159Q13.95,12.921200476837159,13.95,12.812500476837158L13.95,10.275000476837159L11.15,10.275000476837159L11.15,13.075000476837157ZM13.95,9.224990476837158L13.95,6.774990476837158L11.15,6.774990476837158L11.15,9.224990476837158L13.95,9.224990476837158ZM13.95,5.724990476837158L13.95,3.187500476837158Q13.95,2.925000476837158,13.6875,2.925000476837158L2.3125,2.925000476837158Q2.20377,2.925000476837158,2.12688,3.001880476837158Q2.05,3.078770476837158,2.05,3.187500476837158L2.05,5.724990476837158L13.95,5.724990476837158ZM2.05,6.774990476837158L2.05,9.224990476837158L5.2875,9.224990476837158L5.2875,6.774990476837158L2.05,6.774990476837158ZM6.3375,6.774990476837158L10.1,6.774990476837158L10.1,9.224990476837158L6.3375,9.224990476837158L6.3375,6.774990476837158Z",
    fillRule: "evenodd",
    fill: "#FFB300",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableActiveUltra);
export default __webpack_public_path__ + "static/media/icon-table-active-ultra.8477d65a06fd26d8bb5c477904f60b0f.svg";
export { ForwardRef as ReactComponent };